var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "akar-icons:search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 14L11.0093 11.004L14 14ZM12.6667 7.00001C12.6667 8.5029 12.0696 9.94424 11.0069 11.0069C9.94424 12.0697 8.5029 12.6667 7 12.6667C5.49711 12.6667 4.05577 12.0697 2.99306 11.0069C1.93036 9.94424 1.33334 8.5029 1.33334 7.00001C1.33334 5.49712 1.93036 4.05578 2.99306 2.99307C4.05577 1.93037 5.49711 1.33334 7 1.33334C8.5029 1.33334 9.94424 1.93037 11.0069 2.99307C12.0696 4.05578 12.6667 5.49712 12.6667 7.00001V7.00001Z",
    stroke: "#2A7F57",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.c6d48ce88eaa223f8a07b81f610ef442.svg";
export { ForwardRef as ReactComponent };